import React, { Fragment, useContext, useEffect } from 'react';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

import {
  LicensesContext,
  actionTypes,
} from 'containers/pages/BillingLicenses/licensesContext';

import { sort } from './helpers';
import { LicensesRow } from './components/LicensesRow';
import { ShadowDom } from './components/ShadowDom';

const LicensesList = ({ toggleDrawer }) => {
  const {
    dispatch,
    licensesState: {
      licenseListIsLoading,
      licenseList,
      sortType,
      sortField,
      sortDirection,
      searchTerm,
      viewList,
    },
  } = useContext(LicensesContext);

  useEffect(() => {
    dispatch({
      type: actionTypes.SET_VIEW_LIST,
      viewList: sort(licenseList, sortType, sortField, sortDirection),
    });
  }, [sortField, sortDirection, licenseList, searchTerm]);

  const Row = ({ index, style }) => {
    return (
      <LicensesRow
        key={index}
        license={viewList[index]}
        style={style}
        toggleDrawer={toggleDrawer}
      />
    );
  };

  return (
    <Fragment>
      {licenseListIsLoading && <ShadowDom />}
      <AutoSizer defaultWidth="100%">
        {({ height, width }) => (
          <FixedSizeList
            height={height}
            width={width}
            className="m-data-list"
            itemCount={viewList.length}
            itemSize={71}
          >
            {Row}
          </FixedSizeList>
        )}
      </AutoSizer>
    </Fragment>
  );
};

export default LicensesList;
